@if (isLocationSelected && selectedLocations.length == 1 && reorderBannerUrl && cmsReorderResponse?.reorderProducts) {
  <section
    class="reorder">
    <section class="col-md-12 col-sm-12 p0">
      <section class="reorder_banner">
        <img class="banner-poster" src="{{ reorderBannerUrl }}" alt="" />
      </section>
      <section class="reOrder-text">
        <div class="" [innerHTML]="cmsReorderResponse?.text"></div>
        <button type="button" class="btn-primary view-btn" (click)="viewReorderPopup()">View
        and reorder products.</button>
      </section>
    </section>
  </section>
}
<section class="col-12 col-xs-12 col-sm-7 col-md-8 left-section">
  <app-order-list></app-order-list>
</section>

<!--end-->